import { taskTypesSlice } from "./taskTypesSlice";
import * as defaultActions from "../../../../../redux/_common";

import * as constants from "./constants";
import { Dispatch } from "redux";
import { get } from "../../../../../api/requester";

export const QPARAMS_CHANGED = "taskTypes/QParamsChanged";
const { actions } = taskTypesSlice;

export const setValidationErrors = actions.setValidationErrors;
const moduleUrl = '/api/activity/tasktypes'

export const getTaskTypeSurveys = (taskTypeId:string) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setTaskSurveysLoading(true));
    const res = await get(`${moduleUrl}/${taskTypeId}/surveys`);
    dispatch(actions.setTaskSurveys(res));
  } catch (e) {
    
  } finally {
    dispatch(actions.setTaskSurveysLoading(false));
  }
}

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearTaskSurveys = () => actions.clearTaskSurveys();
export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
